module.exports = __webpack_public_path__ + "img/austria-ill-defined-causes-male.20635555.png";